// nkMahnNoticeService – read-only Abruf der Hinweis-Zusammenfassung
// (offene NK-Forderungen + Mahnstufen). Keine Schreiboperationen.
import { masterSupabase as supabase } from '../lib/supabase-master.js';

const nkMahnNoticeService = {
  async getSession() {
    return supabase.auth.getSession();
  },
  async getSummary() {
    const { data: { session } } = await supabase.auth.getSession();
    const response = await fetch('/api/rent/notice-summary', {
      headers: {
        'x-supabase-access-token': session?.access_token || '',
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('notice_summary_failed');
    return response.json();
  }
};

export default nkMahnNoticeService;
